import { WE_SPIN_EVENT_TAG_ALL_TEXT_KEYS } from './we-spin-event-tags.js';

export const WE_SPIN_WEEKDAYS = [
	'WE_SPIN_WEEKDAYS_SUN',
	'WE_SPIN_WEEKDAYS_MON',
	'WE_SPIN_WEEKDAYS_TUE',
	'WE_SPIN_WEEKDAYS_WED',
	'WE_SPIN_WEEKDAYS_THU',
	'WE_SPIN_WEEKDAYS_FRI',
	'WE_SPIN_WEEKDAYS_SAT'
];

export const WE_SPIN_MONTHS = [
	'WE_SPIN_MONTHS_JAN',
	'WE_SPIN_MONTHS_FEB',
	'WE_SPIN_MONTHS_MAR',
	'WE_SPIN_MONTHS_APR',
	'WE_SPIN_MONTHS_MAY',
	'WE_SPIN_MONTHS_JUN',
	'WE_SPIN_MONTHS_JUL',
	'WE_SPIN_MONTHS_AUG',
	'WE_SPIN_MONTHS_SEP',
	'WE_SPIN_MONTHS_OCT',
	'WE_SPIN_MONTHS_NOV',
	'WE_SPIN_MONTHS_DEC'
];

export const WE_SPIN_START_TIME_TEXT_KEYS = [
	'WE_SPIN_START_TIME_STREAM_ENDED',
	'WE_SPIN_START_TIME_LIVE',
	'WE_SPIN_START_TIME_STREAM_CANCELLED',
	'WE_SPIN_START_TIME_LAST_CHANCE_TO_BUY_IN',
	'WE_SPIN_START_TIME_STARTS_AT',
	'WE_SPIN_START_TIME_STARTS_NOW',
	'WE_SPIN_START_TIME_STARTS_IN',
	'WE_SPIN_START_TIME_OPENS_IN',
	'WE_SPIN_START_TIME_FREE_WESPIN_STARTS_NOW',
	'WE_SPIN_START_TIME_OPENS'
]
	.concat(WE_SPIN_WEEKDAYS)
	.concat(WE_SPIN_MONTHS);

export const WE_SPIN_BANNER_TEXT_KEYS = [
	'WE_SPIN_BANNER_BALANCE',
	'WE_SPIN_BANNER_NET_RESULT',
	'WE_SPIN_BANNER_TIME',
	'WE_SPIN_START_BALANCE'
];
export const WE_SPIN_LOBBY_CARD_TEXT_KEYS = [
	'WE_SPIN_LOBBY_CARD_BALANCE',
	'WE_SPIN_LOBBY_CARD_BALANCE_REFUNDED',
	'WE_SPIN_LOBBY_CARD_LENGTH',
	'WE_SPIN_LOBBY_CARD_BUTTON_FULLY_BOOKED',
	'WE_SPIN_LOBBY_CARD_BUTTON_YOUR_BUY_IN',
	'WE_SPIN_LOBBY_CARD_BUTTON_VIEW_RESULT',
	'WE_SPIN_LOBBY_CARD_BUTTON_VIEW',
	'WE_SPIN_LOBBY_CARD_BUTTON_STREAM_CANCELLED',
	'WE_SPIN_LOBBY_CARD_BUTTON_JOIN_US',
	'WE_SPIN_LOBBY_CARD_TRY_GAME_TITLE',
	'WE_SPIN_LOBBY_CARD_TRY_GAME_TEXT',
	'WE_SPIN_LOBBY_CARD_BUTTON_JOIN',
	'WE_SPIN_LOBBY_CARD_PLAYER_TEXT',
	'WE_SPIN_LOBBY_CARD_PLAYERS_TEXT',
	'WE_SPIN_LOBBY_CARD_TUTORIAL_CAPTION',
	'WE_SPIN_LOBBY_CARD_TUTORIAL_TITLE',
	'WE_SPIN_LOBBY_CARD_TUTORIAL_DESCRIPTION',
	'WE_SPIN_LOBBY_CARD_TUTORIAL_BUTTON_TEXT',
	'WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_CAPTION',
	'WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_TITLE',
	'WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_DESCRIPTION',
	'WE_SPIN_FRIENDS_LOBBY_CARD_TUTORIAL_BUTTON_TEXT',
	'WE_SPIN_LOBBY_CARD_EVENT_TAG_BONUS_HUNT',
	'WE_SPIN_LOBBY_CARD_BUTTON_JOINED',
	'WE_SPIN_LOBBY_CARD_BUTTON_GO_TO_EVENT',
	'WE_SPIN_LOBBY_CARD_ONLINE'
];

export const WE_SPIN_LOBBY_TEXT_KEYS = ['WE_SPIN_LOBBY_UPCOMING', 'WE_SPIN_LOBBY_JOINED'];
export const WE_SPIN_LOBBY_MOBILE_INFO_TEXT_KEYS = [
	'WE_SPIN_LOBBY_MOBILE_INFO_NOT_LOGGED_IN',
	'WE_SPIN_LOBBY_MOBILE_INFO_NOT_LOGGED_IN_MSG',
	'WE_SPIN_LOBBY_MOBILE_INFO_NO_JOINED_WE_SPIN',
	'WE_SPIN_LOBBY_MOBILE_INFO_NO_JOINED_WE_SPIN_MSG'
];
export const WE_SPIN_SESSION_INFO_TEXT_KEYS = [
	'WE_SPIN_LOBBY_SESSION_INFO_GAME_LENGTH',
	'WE_SPIN_LOBBY_SESSION_INFO_PLAYERS',
	'WE_SPIN_LOBBY_SESSION_INFO_LANGUAGE',
	'WE_SPIN_LOBBY_SESSION_INFO_STARTS'
];
export const WE_SPIN_CHANGE_USERNAME_NOTIFICATION_SUCCESS_INFO = 'WE_SPIN_CHANGE_USERNAME_NOTIFICATION_SUCCESS_INFO';
export const WE_SPIN_CHANGE_DISPLAY_NAME_TEXT_KEYS = [
	'WE_SPIN_CHANGE_USERNAME_WE_SPIN_NAME',
	'WE_SPIN_CHANGE_USERNAME_NAME',
	'WE_SPIN_CHANGE_USERNAME_NAME_VALIDATION_ERROR',
	'WE_SPIN_CHANGE_USERNAME_NAME_INFO',
	'WE_SPIN_CHANGE_USERNAME_NAME_SAVE',
	WE_SPIN_CHANGE_USERNAME_NOTIFICATION_SUCCESS_INFO
];

export const WE_SPIN_ERROR_NOTIFICATION_TITLE = 'WE_SPIN_ERROR_NOTIFICATION_TITLE';
export const WE_SPIN_SERVER_ERROR_BAD_REQUEST = 'WE_SPIN_SERVER_ERROR_BAD_REQUEST';
export const WE_SPIN_SERVER_ERROR_INSUFFICIENT_FUNDS = 'WE_SPIN_SERVER_ERROR_INSUFFICIENT_FUNDS';
export const WE_SPIN_SERVER_ERROR_UNAUTHORIZED_REQUEST = 'WE_SPIN_SERVER_ERROR_UNAUTHORIZED_REQUEST';
export const WE_SPIN_SERVER_ERROR_NOT_FOUND = 'WE_SPIN_SERVER_ERROR_NOT_FOUND';
export const WE_SPIN_SERVER_ERROR_NOT_LOGGED_IN = 'WE_SPIN_SERVER_ERROR_NOT_LOGGED_IN';
export const WE_SPIN_SERVER_ERROR_STREAM_ALREADY_RUNNING = 'WE_SPIN_SERVER_ERROR_STREAM_ALREADY_RUNNING';
export const WE_SPIN_SERVER_ERROR_GENERAL_ERROR = 'WE_SPIN_SERVER_ERROR_GENERAL_ERROR';

export const WE_SPIN_ERROR_HANDLER_TEXT_KEYS = [
	WE_SPIN_ERROR_NOTIFICATION_TITLE,
	WE_SPIN_SERVER_ERROR_BAD_REQUEST,
	WE_SPIN_SERVER_ERROR_INSUFFICIENT_FUNDS,
	WE_SPIN_SERVER_ERROR_UNAUTHORIZED_REQUEST,
	WE_SPIN_SERVER_ERROR_NOT_FOUND,
	WE_SPIN_SERVER_ERROR_NOT_LOGGED_IN,
	WE_SPIN_SERVER_ERROR_STREAM_ALREADY_RUNNING,
	WE_SPIN_SERVER_ERROR_GENERAL_ERROR
];

export const WE_SPIN_BUY_IN_AMOUNT_BALANCE_CAP_EXCEEDED = 'WE_SPIN_BUY_IN_AMOUNT_BALANCE_CAP_EXCEEDED';

export const WE_SPIN_BUY_IN_LOW_AMOUNT = 'WE_SPIN_BUY_IN_LOW_AMOUNT';
export const WE_SPIN_BUY_IN_MID_AMOUNT = 'WE_SPIN_BUY_IN_MID_AMOUNT';
export const WE_SPIN_BUY_IN_HIGH_AMOUNT = 'WE_SPIN_BUY_IN_HIGH_AMOUNT';

export const WE_SPIN_BET_SIZE_TEXT_KEYS = ['WE_SPIN_BET_SIZE_RANGE_LABEL', 'WE_SPIN_BET_SIZE_RANGE_TEXT'];

export const WE_SPIN_RAFFLE_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_RAFFLE_TICKETS_LABEL',
	'WE_SPIN_YOUR_RAFFLE_LABEL',
	'WE_SPIN_YOUR_RAFFLE_TICKET_INFO'
];

export const WE_SPIN_BUY_IN_TEXT_KEYS = [
	'WE_SPIN_BUY_IN_AMOUNT_CHOOSE_PREDEFINED_AMOUNTS',
	'WE_SPIN_BUY_IN_AMOUNT_PLACEHOLDER',
	'WE_SPIN_BUY_IN_AMOUNT_PLACEHOLDER_CUSTOM',
	'WE_SPIN_BUY_IN_MINIMUM_AMOUNT',
	'WE_SPIN_BUY_IN_AMOUNT_WELCOME_MSG',
	'WE_SPIN_BUY_IN_MAX_AMOUNT_REACHED',
	'WE_SPIN_BUY_IN_MAX_AMOUNT_ALMOST_REACHED',
	'WE_SPIN_BUY_IN_INSUFFICIENT_FUNDS',
	WE_SPIN_BUY_IN_AMOUNT_BALANCE_CAP_EXCEEDED,
	'WE_SPIN_BUY_IN_BUTTON',
	'WE_SPIN_BUY_IN_CONFIRM_TITLE',
	'WE_SPIN_BUY_IN_CONFIRM_BUTTON',
	'WE_SPIN_BUY_IN_CONFIRM_CANCEL_BUTTON',
	'WE_SPIN_BUY_IN_CONFIRM_MSG_ROW_ONE',
	'WE_SPIN_BUY_IN_CONFIRM_MSG_ROW_TWO',
	'WE_SPIN_BUY_IN_BALANCE_LABEL',
	'WE_SPIN_BUY_IN_BALANCE_TEXT',
	'WE_SPIN_BUY_IN_STARTS_LABEL',
	'WE_SPIN_BUY_IN_STARTS_TEXT',
	'WE_SPIN_BUY_IN_PLAYERS_LABEL',
	'WE_SPIN_BUY_IN_PLAYERS_TEXT',
	'WE_SPIN_BUY_IN_LANGUAGE_LABEL',
	'WE_SPIN_BUY_IN_LANGUAGE_TEXT',
	'WE_SPIN_BUY_IN_WESPIN_BALANCE_LABEL',
	'WE_SPIN_BUY_IN_WESPIN_BALANCE_TEXT',
	'WE_SPIN_BUY_IN_BET_RANGE_LABEL',
	'WE_SPIN_BUY_IN_BET_RANGE_TEXT',
	'WE_SPIN_BUY_IN_WESPIN_BALANCE_CAP_LABEL',
	'WE_SPIN_BUY_IN_WESPIN_BALANCE_CAP_TEXT',
	'WE_SPIN_BUY_IN_WESPIN_TOC_LABEL',
	'WE_SPIN_BUY_IN_WESPIN_TOC_DESCRIPTION',
	'WE_SPIN_BUY_IN_WESPIN_TOC_TEXT',
	'WE_SPIN_BUY_IN_CREATE_USERNAME_MSG',
	'WE_SPIN_BUY_IN_ENTER_USERNAME_PLACEHOLDER',
	'WE_SPIN_BUY_IN_ENTER_USERNAME_TITLE',
	'WE_SPIN_BUY_IN_CREATE_USERNAME_CONFIRM',
	'WE_SPIN_BUY_IN_CREATE_USERNAME_CANCEL',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_TITLE',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_TEXT',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CONFIRM',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CANCEL',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_NEW_AMOUNT',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CURRENT_BALANCE',
	'WE_SPIN_BUY_IN_BALANCE_CAP_MET_TITLE',
	'WE_SPIN_BUY_IN_BALANCE_CAP_MET_TEXT',
	'WE_SPIN_BUY_IN_BALANCE_CAP_MET_BUTTON',
	WE_SPIN_BUY_IN_LOW_AMOUNT,
	WE_SPIN_BUY_IN_MID_AMOUNT,
	WE_SPIN_BUY_IN_HIGH_AMOUNT,
	'WE_SPIN_BUY_IN_LANGUAGE_SV',
	'WE_SPIN_BUY_IN_LANGUAGE_NO',
	'WE_SPIN_BUY_IN_LANGUAGE_FI',
	'WE_SPIN_BUY_IN_LANGUAGE_EN',
	'WE_SPIN_BUY_IN_MY_BALANCE_IN_LABEL',
	'WE_SPIN_BUY_IN_MY_BALANCE_IN_TEXT',
	'WE_SPIN_BUY_IN_BOOST_AMOUNT_LABEL',
	'WE_SPIN_BUY_IN_BOOST_AMOUNT_TEXT',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TITLE',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TEXT',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_DATE',
	'WE_SPIN_BUY_IN_YOUR_BOUGHT',
	'WE_SPIN_BUY_IN_YOUR_BOUGHT_HINT',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TIME',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_PLAYER_CAP_EXCEEDED',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_DEPOSIT_REQUIRED',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_REGISTER',
	'WE_SPIN_BUY_IN_REMINDER',
	'WE_SPIN_PREVIEW_ROOM_RAFFLE_LABEL',
	'WE_SPIN_BUY_IN_WESPIN_GAMES_LABEL',
	...WE_SPIN_BET_SIZE_TEXT_KEYS
];

export const WE_SPIN_CHAT_ROOM_TEXT_KEYS = [
	'WE_SPIN_CHAT_ROOM_NOT_OPEN_TITLE',
	'WE_SPIN_CHAT_ROOM_NOT_OPEN_TEXT',
	'WE_SPIN_CHAT_ROOM_ACCEPT_TERMS_TITLE',
	'WE_SPIN_CHAT_ROOM_ACCEPT_TERMS_TEXT',
	'WE_SPIN_CHAT_ROOM_ACCEPT_TERMS_ACCEPT_BUTTON',
	'WE_SPIN_CHAT_ROOM_ACCEPT_TERMS_BULLETS',
	'WE_SPIN_CHAT_ROOM_ACCEPT_TERMS_FOOTER',
	'WE_SPIN_CHAT_ROOM_NOT_LOGGED_IN_TITLE',
	'WE_SPIN_CHAT_ROOM_NOT_LOGGED_IN_TEXT',
	'WE_SPIN_CHAT_ROOM_NOT_LOGGED_IN_TITLE',
	'WE_SPIN_CHAT_ROOM_LOGIN_BUTTON'
];

export const WE_SPIN_ENDED_ROOM_TEXT_KEYS = [
	'WE_SPIN_ENDED_ROOM_PLAYER_WON_TITLE',
	'WE_SPIN_ENDED_ROOM_PLAYER_WON_TEXT',
	'WE_SPIN_ENDED_ROOM_PLAYER_LOST_TITLE',
	'WE_SPIN_ENDED_ROOM_PLAYER_LOST_TEXT',
	'WE_SPIN_ENDED_ROOM_RESULT_LABEL',
	'WE_SPIN_ENDED_ROOM_SPECTATOR_TITLE',
	'WE_SPIN_ENDED_ROOM_SPECTATOR_TEXT',
	'WE_SPIN_ENDED_BUY_IN_BUTTON',
	'WE_SPIN_ENDED_GOTO_LOBBY_BUTTON',
	'WE_SPIN_ENDED_GO_TO_STREAM'
];

export const WE_SPIN_NEXT_SESSION_TEXT_KEYS = [
	'WE_SPIN_NEXT_SESSION_LABEL',
	'WE_SPIN_NEXT_SESSION_LABEL_OTHER_STREAMERS',
	'WE_SPIN_NEXT_SESSION_GAME_BALANCE',
	'WE_SPIN_NEXT_SESSION_PLAYERS',
	'WE_SPIN_NEXT_SESSION_FULLY_BOOKED',
	'WE_SPIN_EVENT_LIST_PAYOUT',
	'WE_SPIN_EVENT_LIST_EVENT_ENDED',
	'WE_SPIN_EVENT_LIST_EVENT_CANCELLED',
	'WE_SPIN_EVENT_LIST_EVENT_RUNNING',
	'WE_SPIN_LOBBY_CARD_BUTTON_YOUR_BUY_IN',
	'WE_SPIN_NEXT_SESSION_BUYIN_AND_JOIN',
	'WE_SPIN_NEXT_SESSION_PLAYERS',
	'WE_SPIN_NEXT_SESSION_JOINED',
	'WE_SPIN_LOBBY_CARD_EVENT_TAG_BONUS_HUNT',
	'WE_SPIN_EVENT_LIST_ENDED',
	'WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT',
	'WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT',
	'WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT',
	'WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT',
	'WE_SPIN_NEXT_SESSION_JOIN_FOR_FREE',
	'WE_SPIN_YOU_ARE_REGISTERED',
	'WE_SPIN_NEXT_SESSION_JOINED_FREE_WESPIN',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_JOIN'
]
	.concat(WE_SPIN_WEEKDAYS)
	.concat(WE_SPIN_MONTHS);

export const WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT = 'WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT';
export const WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE = 'WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE';
export const WE_SPIN_GAME_ROOM_TAB_ITEM_TIP = 'WE_SPIN_GAME_ROOM_TAB_ITEM_TIP';
export const WE_SPIN_GAME_ROOM_TAB_ITEM_STREAMER = 'WE_SPIN_GAME_ROOM_TAB_ITEM_STREAMER';

export const WE_SPIN_GAME_ROOM_TAB_ITEM_EVENT_LIST = 'WE_SPIN_GAME_ROOM_TAB_ITEM_EVENT_LIST';

export const WE_SPIN_GAME_ROOM_MY_RETURN = 'WE_SPIN_GAME_ROOM_MY_RETURN';

export const WE_SPIN_GAME_ROOM_FOOTER_TEXT_KEYS = [
	'WE_SPIN_GAME_ROOM_FOOTER_PEEK',
	'WE_SPIN_GAME_FOOTER_BUTTON',
	'WE_SPIN_GAME_ROOM_TAB_ITEM_CHAT',
	'WE_SPIN_GAME_ROOM_TAB_ITEM_BALANCE',
	'WE_SPIN_GAME_ROOM_TAB_ITEM_TIP',
	'WE_SPIN_GAME_ROOM_TAB_ITEM_STREAMER',
	'WE_SPIN_GAME_ROOM_TAB_ITEM_EVENT_LIST'
];

export const WE_SPIN_INFO_ROOM_TEXT_KEYS = [
	'WE_SPIN_INFO_ROOM_CURRENT_RESULT_LABEL',
	'WE_SPIN_INFO_ROOM_CURRENT_RESULT_TEXT',
	'WE_SPIN_INFO_ROOM_CURRENT_BALANCE_LABEL',
	'WE_SPIN_INFO_ROOM_CURRENT_BALANCE_TEXT',
	'WE_SPIN_INFO_ROOM_MY_BUY_IN_LABEL',
	'WE_SPIN_INFO_ROOM_MY_BUY_IN_TEXT',
	'WE_SPIN_INFO_ROOM_MY_BET_RANGE_LABEL',
	'WE_SPIN_INFO_ROOM_MY_BET_RANGE_TEXT',
	'WE_SPIN_INFO_ROOM_BALANCE_SHARE_LABEL',
	'WE_SPIN_INFO_ROOM_BALANCE_SHARE_TEXT',
	'WE_SPIN_INFO_ROOM_PLAYERS_LABEL',
	'WE_SPIN_INFO_ROOM_PLAYERS_TEXT',
	'WE_SPIN_INFO_ROOM_NOT_PARTICIPATING_MSG',
	'WE_SPIN_INFO_ROOM_MAIN_TITLE_BEFORE_RUNNING',
	'WE_SPIN_INFO_ROOM_MAIN_SUB_TITLE_BEFORE_RUNNING',
	'WE_SPIN_BALANCE_INFO_NOT_OPEN_TITLE',
	'WE_SPIN_BALANCE_INFO_NOT_OPEN_TEXT',
	'WE_SPIN_LOBBY_CARD_BUTTON_YOUR_BUY_IN',
	'WE_SPIN_NEXT_SESSION_BUYIN_AND_JOIN',
	'WE_SPIN_NEXT_SESSION_PLAYERS',
	'WE_SPIN_NEXT_SESSION_JOINED',
	'WE_SPIN_LOBBY_CARD_EVENT_TAG_BONUS_HUNT',
	'WE_SPIN_NEXT_SESSION_GAME_BALANCE',
	'WE_SPIN_NEXT_SESSION_BUYIN',
	'WE_SPIN_NEXT_SESSION_FULLY_BOOKED',
	'WE_SPIN_BONUS_HUNT_INFO_TEXT',
	'WE_SPIN_BUY_IN_BOOST_ADD_ON_DESC',
	'WE_SPIN_INFO_ROOM_MY_BOOST_AMOUNT_LABEL',
	'WE_SPIN_INFO_ROOM_MY_BOOST_AMOUNT_TEXT',
	'WE_SPIN_INFO_ROOM_MAIN_TITLE_FREE_WESPIN',
	'WE_SPIN_INFO_ROOM_MAIN_SUB_TITLE_FREE_WESPIN',
	'WE_SPIN_NEXT_SESSION_JOIN_FOR_FREE',
	'WE_SPIN_YOU_ARE_REGISTERED',
	'WE_SPIN_INFO_ROOM_NOT_OPEN_MAIN_TITLE_FREE_WESPIN',
	'WE_SPIN_INFO_ROOM_NOT_OPEN_MAIN_SUB_TITLE_FREE_WESPIN',
	'WE_SPIN_NEXT_SESSION_JOINED_FREE_WESPIN',
	'WE_SPIN_EVENT_TAG_BONUS_HUNT_BG_TEXT',
	'WE_SPIN_EVENT_TAG_JACKPOT_HUNT_BG_TEXT',
	'WE_SPIN_EVENT_TAG_STREAMERS_CHOICE_BG_TEXT',
	'WE_SPIN_EVENT_TAG_BONUS_BUY_BG_TEXT',
	'WE_SPIN_LIVE_EVENT_LINK_TITLE',
	'WE_SPIN_GAME_ROOM_PLAYERS_TITLE',
	'WE_SPIN_GAME_ROOM_PLAYERS_DESC',
	'WE_SPIN_GAME_ROOM_RAFFLE_TITLE',
	'WE_SPIN_GAME_ROOM_RAFFLE_DESC',
	WE_SPIN_GAME_ROOM_MY_RETURN,
	...WE_SPIN_RAFFLE_TEXT_KEYS
];

export const WE_SPIN_PREVIEW_ROOM_UNREGISTER_NOTIFICATION = 'WE_SPIN_PREVIEW_ROOM_UNREGISTER_NOTIFICATION';

export const WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_OVER_CAP_TEXT = 'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_OVER_CAP_TEXT';
export const WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_TOO_LOW_TEXT = 'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_TOO_LOW_TEXT';
export const WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_BALANCE_TOO_LOW_TEXT =
	'WE_SPIN_PREVIEW_ROOM_ADJUST_BALANCE_TOO_LOW_TEXT';

export const WE_SPIN_PREVIEW_ROOM_TEXT_KEYS = [
	WE_SPIN_PREVIEW_ROOM_UNREGISTER_NOTIFICATION,
	'WE_SPIN_PREVIEW_ROOM_LIVE_STREAM_DIALOG_TITLE',
	'WE_SPIN_PREVIEW_ROOM_LIVE_STREAM_DIALOG_TEXT',
	'WE_SPIN_PREVIEW_ROOM_LIVE_STREAM_DIALOG_YES_BUTTON',
	'WE_SPIN_PREVIEW_ROOM_LIVE_STREAM_DIALOG_NO_BUTTON',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_TITLE',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_TEXT',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_YES_BUTTON',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_NO_BUTTON',
	'WE_SPIN_PREVIEW_ROOM_WE_SPIN_BALANCE_LABEL',
	'WE_SPIN_PREVIEW_ROOM_WE_SPIN_BALANCE_TEXT',
	'WE_SPIN_PREVIEW_ROOM_MY_BALANCE_LABEL',
	'WE_SPIN_PREVIEW_ROOM_REFUND_BUTTON',
	'WE_SPIN_PREVIEW_ROOM_REFUND_INFO',
	'WE_SPIN_PREVIEW_ROOM_EDIT_AMOUNT',
	'WE_SPIN_PREVIEW_ROOM_PLAYERS_LABEL',
	'WE_SPIN_PREVIEW_ROOM_PLAYERS_TEXT',
	'WE_SPIN_PREVIEW_ROOM_EDIT_AMOUNT_TITLE',
	'WE_SPIN_PREVIEW_ROOM_EDIT_AMOUNT_TEXT',
	'WE_SPIN_PREVIEW_ROOM_EDIT_AMOUNT_YES_BUTTON_TEXT',
	'WE_SPIN_PREVIEW_ROOM_EDIT_AMOUNT_NO_BUTTON_TEXT',
	'WE_SPIN_PREVIEW_ROOM_EDIT_AMOUNT_PLACEHOLDER',
	'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_TITLE',
	WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_OVER_CAP_TEXT,
	WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_TOO_LOW_TEXT,
	WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_BALANCE_TOO_LOW_TEXT,
	'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_CONFIRM',
	'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_CANCEL',
	'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_CURRENT_BALANCE',
	'WE_SPIN_PREVIEW_ROOM_ADJUST_AMOUNT_NEW_AMOUNT',
	'WE_SPIN_PREVIEW_ROOM_COPY_LINK_DESC',
	'WE_SPIN_PREVIEW_ROOM_BUTTON_COPY_LINK',
	'WE_SPIN_BET_SIZE_RANGE_LABEL',
	'WE_SPIN_BET_SIZE_RANGE_TEXT',
	'WE_SPIN_PREVIEW_ROOM_SELECTED_GAMES_LABEL',
	...WE_SPIN_BET_SIZE_TEXT_KEYS,
	...WE_SPIN_RAFFLE_TEXT_KEYS
];

export const WE_SPIN_CANCELLED_ROOM_TEXT_KEYS = [
	'WE_SPIN_CANCELLED_ROOM_TITLE',
	'WE_SPIN_CANCELLED_ROOM_TEXT_PT1',
	'WE_SPIN_CANCELLED_ROOM_TEXT_PT2',
	'WE_SPIN_CANCELLED_ROOM_REFUNDED_AMOUNT_LABEL'
];

export const WE_SPIN_SPECTATOR_ROOM_TEXT_KEYS = [
	'WE_SPIN_SPECTATOR_ROOM_IS_FULL_TITLE',
	'WE_SPIN_SPECTATOR_ROOM_IS_FULL_TEXT',
	'WE_SPIN_SPECTATOR_ROOM_IS_LIVE_TITLE',
	'WE_SPIN_SPECTATOR_ROOM_IS_LIVE_TEXT'
];

export const WE_SPIN_RULES_TEXT_KEYS = [
	'WE_SPIN_RULES_HEADER',
	'WE_SPIN_RULES',
	'WE_SPIN_RULES_TITLE',
	'WE_SPIN_RULES_SUB_TITLE',
	'WE_SPIN_RULES_TERMS_AND_CONDITIONS_LABEL',
	'WE_SPIN_BUY_IN_WESPIN_TOC_TEXT'
];

export const WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_TEXT_KEYS = [
	'WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_WE_SPIN_GAME_RULES_BUTTON',
	'WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_GAME_RULES_BUTTON',
	'WE_SPIN_GAME_ROOM_SIDEBAR_MODAL_CANCEL_BUTTON',
	'WE_SPIN_RULES'
];

export const WE_SPIN_TIPPING_ROOM_TEXT_KEYS = [
	'WE_SPIN_TIPPING_ROOM_TIP_PLACEHOLDER',
	'WE_SPIN_TIPPING_ROOM_TIP_HEADER_TITLE',
	'WE_SPIN_TIPPING_ROOM_TIP_HEADER_TEXT',
	'WE_SPIN_TIPPING_ROOM_TIP_CONFIRM_HEADER',
	'WE_SPIN_TIPPING_ROOM_TIP_CONFIRM_TEXT',
	'WE_SPIN_TIPPING_ROOM_TIP_CONFIRM_BUTTON',
	'WE_SPIN_TIPPING_ROOM_TIP_CANCEL_BUTTON',
	'WE_SPIN_TIPPING_ROOM_TIP_YOUR_TIP_LABEL',
	'WE_SPIN_TIPPING_ROOM_TIP_BUTTON',
	'WE_SPIN_TIPPING_ROOM_TIP_DONE_HEADER',
	'WE_SPIN_TIPPING_ROOM_TIP_DONE_TEXT_PT1',
	'WE_SPIN_TIPPING_ROOM_TIP_DONE_TEXT_PT2'
];

export const WE_SPIN_GAME_VIEW_TEXT_KEYS = [
	'WE_SPIN_GAME_VIEW_ENDED_TITLE',
	'WE_SPIN_GAME_VIEW_ENDED_TEXT',
	'WE_SPIN_GAME_VIEW_CANCELLED_TITLE',
	'WE_SPIN_GAME_VIEW_OFFLINE_TITLE'
];

export const WE_SPIN_ACCOUNT_TEXT_KEYS = [
	'WE_SPIN_ACCOUNT_DISPLAY_NAME_TITLE',
	'WE_SPIN_ACCOUNT_DASHBOARD_TITLE',
	'WE_SPIN_ACCOUNT_NOTIFICATION_OPT_OUT_TITLE',
	'WE_SPIN_ACCOUNT_NOTIFICATION_OPT_OUT_MESSAGE',
	'WE_SPIN_ACCOUNT_NOTIFICATIONS_ON',
	'WE_SPIN_ACCOUNT_NOTIFICATIONS_OFF',
	'WE_SPIN_ACCOUNT_NOTIFICATIONS_SETTINGS_LABEL',
	'WE_SPIN_NOTIFICATION_OPT_OUT_SUCCESSFUL'
];

export const WE_SPIN_STREAMER_IN_GAME_HEADER_TEXT_KEYS = ['WE_SPIN_STREAMER_IN_GAME_HEADER_BALANCE_LABEL'];

export const WE_SPIN_ONBOARDING_ITEM_1_HEADER = 'WE_SPIN_ONBOARDING_ITEM_1_HEADER';
export const WE_SPIN_ONBOARDING_ITEM_1_CONTENT = 'WE_SPIN_ONBOARDING_ITEM_1_CONTENT';
export const WE_SPIN_ONBOARDING_ITEM_2_HEADER = 'WE_SPIN_ONBOARDING_ITEM_2_HEADER';
export const WE_SPIN_ONBOARDING_ITEM_2_CONTENT = 'WE_SPIN_ONBOARDING_ITEM_2_CONTENT';
export const WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_2 = 'WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_2';
export const WE_SPIN_ONBOARDING_ITEM_3_HEADER = 'WE_SPIN_ONBOARDING_ITEM_3_HEADER';
export const WE_SPIN_ONBOARDING_ITEM_3_CONTENT = 'WE_SPIN_ONBOARDING_ITEM_3_CONTENT';
export const WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_3 = 'WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_3';
export const WE_SPIN_ONBOARDING_ITEM_4_HEADER = 'WE_SPIN_ONBOARDING_ITEM_4_HEADER';
export const WE_SPIN_ONBOARDING_ITEM_4_CONTENT = 'WE_SPIN_ONBOARDING_ITEM_4_CONTENT';
export const WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_4 = 'WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_4';
export const WE_SPIN_ONBOARDING_ITEM_5_HEADER = 'WE_SPIN_ONBOARDING_ITEM_5_HEADER';
export const WE_SPIN_ONBOARDING_ITEM_5_CONTENT = 'WE_SPIN_ONBOARDING_ITEM_5_CONTENT';
export const WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_5 = 'WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_5';
export const WE_SPIN_ONBOARDING_ITEM_6_HEADER = 'WE_SPIN_ONBOARDING_ITEM_6_HEADER';
export const WE_SPIN_ONBOARDING_ITEM_6_CONTENT = 'WE_SPIN_ONBOARDING_ITEM_6_CONTENT';
export const WE_SPIN_ONBOARDING_ITEM_START_ONBOARDING_TEXT = 'WE_SPIN_ONBOARDING_ITEM_START_ONBOARDING_TEXT';
export const WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT = 'WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT';
export const WE_SPIN_ONBOARDING_ITEM_CLOSE_TEXT = 'WE_SPIN_ONBOARDING_ITEM_CLOSE_TEXT';
export const WE_SPIN_ONBOARDING_ITEM_FINISH_TEXT = 'WE_SPIN_ONBOARDING_ITEM_FINISH_TEXT';

export const WE_SPIN_ONBOARDING_TEXT_KEYS = [
	WE_SPIN_ONBOARDING_ITEM_1_HEADER,
	WE_SPIN_ONBOARDING_ITEM_1_CONTENT,
	WE_SPIN_ONBOARDING_ITEM_2_HEADER,
	WE_SPIN_ONBOARDING_ITEM_2_CONTENT,
	WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_2,
	WE_SPIN_ONBOARDING_ITEM_3_HEADER,
	WE_SPIN_ONBOARDING_ITEM_3_CONTENT,
	WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_3,
	WE_SPIN_ONBOARDING_ITEM_4_HEADER,
	WE_SPIN_ONBOARDING_ITEM_4_CONTENT,
	WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_4,
	WE_SPIN_ONBOARDING_ITEM_5_HEADER,
	WE_SPIN_ONBOARDING_ITEM_5_CONTENT,
	WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT_5,
	WE_SPIN_ONBOARDING_ITEM_6_HEADER,
	WE_SPIN_ONBOARDING_ITEM_6_CONTENT,
	WE_SPIN_ONBOARDING_ITEM_START_ONBOARDING_TEXT,
	WE_SPIN_ONBOARDING_ITEM_CONTINUE_TEXT,
	WE_SPIN_ONBOARDING_ITEM_CLOSE_TEXT,
	WE_SPIN_ONBOARDING_ITEM_FINISH_TEXT
];

export const WE_SPIN_SEO = ['META_KEYWORDS_WE_SPIN', 'META_DESCRIPTION_WE_SPIN', 'WE_SPIN_SITE_TITLE'];

export const WE_SPIN_NOTIFICATION_TEXT_KEYS = [
	'WE_SPIN_NOTIFICATION_MESSAGE_1',
	'WE_SPIN_NOTIFICATION_MESSAGE_2',
	'WE_SPIN_NOTIFICATION_BUTTON_TEXT',
	'WE_SPIN_NOTIFICATION_OPT_OUT_TEXT'
];

export const WE_SPIN_SHARE_TEXT_KEYS = [
	'WE_SPIN_SHARE_URL_COPIED_TO_CLIPBOARD',
	'WE_SPIN_SHARE_BUTTON_TEXT',
	'WE_SPIN_SHARE_BUTTON_SHARE_LINK',
	'WE_SPIN_SHARE_TITLE',
	'WE_SPIN_SHARE_MESSAGE',
	'WE_SPIN_SHARE_SUCCESS',
	'WE_SPIN_SHARE_FAILURE'
];

export const WE_SPIN_TAKE_ME_TO_EVENT_TEXT_KEYS = [
	'WE_SPIN_DASHBOARD_SCHEDULED_TAKE_ME_TO_EVENT_BUTTON',
	'WE_SPIN_TAKE_ME_TO_EVENT_FAILURE',
	'WE_SPIN_TAKE_ME_TO_EVENT_SUCCESS'
];

export const WE_SPIN_CLIP_TEXT_KEYS = [
	'WE_SPIN_CLIP_CARD_MAIN_CAPTION',
	'WE_SPIN_CLIP_CARD_ADD_BUTTON',
	'WE_SPIN_CLIP_CARD_TIME_FOR_REVIEW_CAPTION',
	'WE_SPIN_CLIP_CARD_STREAMER_HEADER',
	'WE_SPIN_CLIP_CARD_NOT_STREAMER_HEADER',
	'WE_SPIN_CLIP_MODAL_TITLE',
	'WE_SPIN_CLIP_MODAL_TEXT',
	'WE_SPIN_CLIP_MODAL_OK',
	'WE_SPIN_CLIP_MODAL_CANCEL',
	'WE_SPIN_CLIP_MODAL_VALIDATION_ERROR',
	'WE_SPIN_CLIP_MODAL_INPUT_PLACEHOLDER',
	'WE_SPIN_CLIP_MODAL_SUCCESS'
];

export const WE_SPIN_BECOME_PRIVATE_STREAMER_TEXT_KEYS = [
	'WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_TITLE',
	'WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_CONTENT',
	'WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_BUTTON',
	'WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_TUTORIAL_TEXT',
	'WE_SPIN_BECOME_PRIVATE_STREAMER_CARD_TUTORIAL_BUTTON'
];

export const WE_SPIN_FOLLOW_STREAMER_TEXT_KEYS = [
	'WE_SPIN_FOLLOW_STREAMER_FOLLOW',
	'WE_SPIN_FOLLOW_STREAMER_CAPTION',
	'WE_SPIN_FOLLOW_STREAMER_FOLLOWERS'
];

export const WE_SPIN_MODALS_TEXT_KEYS = [
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_TITLE',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_TEXT',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CONFIRM',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CANCEL',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CURRENT_BALANCE',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_NEW_AMOUNT',
	'WE_SPIN_BUY_IN_REMINDER',
	'WE_SPIN_BUY_IN_BALANCE_CAP_MET_TITLE',
	'WE_SPIN_BUY_IN_BALANCE_CAP_MET_TEXT',
	'WE_SPIN_BUY_IN_BALANCE_CAP_MET_BUTTON',
	'WE_SPIN_BUY_IN_CONFIRM_TITLE',
	'WE_SPIN_BUY_IN_CONFIRM_MSG_ROW_ONE',
	'WE_SPIN_BUY_IN_CONFIRM_MSG_ROW_TWO',
	'WE_SPIN_BUY_IN_CONFIRM_BUTTON',
	'WE_SPIN_BUY_IN_CONFIRM_CANCEL_BUTTON',
	'WE_SPIN_BUY_IN_BALANCE_LABEL',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_TITLE',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_TEXT',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_YES_BUTTON',
	'WE_SPIN_PREVIEW_ROOM_REFUND_DIALOG_NO_BUTTON',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TITLE',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TEXT',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_DATE',
	'WE_SPIN_BUY_IN_FREE_WE_SPIN_MODAL_TIME',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_TITLE',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_TEXT',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_YES_BUTTTON',
	'WE_SPIN_DASHBOARD_SCHEDULED_REMOVE_STREAM_NO_BUTTTON',
	'WE_SPIN_BUY_IN_ENTER_USERNAME_TITLE',
	'WE_SPIN_BUY_IN_CREATE_USERNAME_MSG',
	'WE_SPIN_BUY_IN_CREATE_USERNAME_CONFIRM',
	'WE_SPIN_BUY_IN_CREATE_USERNAME_CANCEL',
	'WE_SPIN_BUY_IN_ENTER_USERNAME_PLACEHOLDER',
	'WE_SPIN_CHANGE_USERNAME_NAME_VALIDATION_ERROR',
	'WE_SPIN_BUY_IN_ADJUST_AMOUNT_CURRENT_BUYIN_TEXT'
];

export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_1_HEADER = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_1_HEADER';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_1_CONTENT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_1_CONTENT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_2_HEADER = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_2_HEADER';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_2_CONTENT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_2_CONTENT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_2 = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_2';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_3_HEADER = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_3_HEADER';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_3_CONTENT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_3_CONTENT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_3 = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_3';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_4_HEADER = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_4_HEADER';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_4_CONTENT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_4_CONTENT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_4 = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_4';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_5_HEADER = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_5_HEADER';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_5_CONTENT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_5_CONTENT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_5 = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_5';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_6_HEADER = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_6_HEADER';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_6_CONTENT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_6_CONTENT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_START_ONBOARDING_TEXT =
	'WE_SPIN_FRIENDS_ONBOARDING_ITEM_START_ONBOARDING_TEXT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_CLOSE_TEXT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_CLOSE_TEXT';
export const WE_SPIN_FRIENDS_ONBOARDING_LAST_ITEM_CLOSE_TEXT = 'WE_SPIN_FRIENDS_ONBOARDING_LAST_ITEM_CLOSE_TEXT';
export const WE_SPIN_FRIENDS_ONBOARDING_ITEM_FINISH_TEXT = 'WE_SPIN_FRIENDS_ONBOARDING_ITEM_FINISH_TEXT';

export const WE_SPIN_FRIENDS_ONBOARDING_TEXT_KEYS = [
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_1_HEADER,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_1_CONTENT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_2_HEADER,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_2_CONTENT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_2,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_3_HEADER,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_3_CONTENT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_3,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_4_HEADER,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_4_CONTENT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_4,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_5_HEADER,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_5_CONTENT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT_5,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_6_HEADER,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_6_CONTENT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_START_ONBOARDING_TEXT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_CONTINUE_TEXT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_CLOSE_TEXT,
	WE_SPIN_FRIENDS_ONBOARDING_LAST_ITEM_CLOSE_TEXT,
	WE_SPIN_FRIENDS_ONBOARDING_ITEM_FINISH_TEXT
];

export const WE_SPIN_ALL_TEXT_KEYS = [
	...new Set([
		...WE_SPIN_START_TIME_TEXT_KEYS,
		...WE_SPIN_LOBBY_CARD_TEXT_KEYS,
		...WE_SPIN_LOBBY_TEXT_KEYS,
		...WE_SPIN_LOBBY_MOBILE_INFO_TEXT_KEYS,
		...WE_SPIN_SESSION_INFO_TEXT_KEYS,
		...WE_SPIN_CHANGE_DISPLAY_NAME_TEXT_KEYS,
		...WE_SPIN_ERROR_HANDLER_TEXT_KEYS,
		...WE_SPIN_BUY_IN_TEXT_KEYS,
		...WE_SPIN_ENDED_ROOM_TEXT_KEYS,
		...WE_SPIN_NEXT_SESSION_TEXT_KEYS,
		...WE_SPIN_GAME_ROOM_FOOTER_TEXT_KEYS,
		...WE_SPIN_INFO_ROOM_TEXT_KEYS,
		...WE_SPIN_PREVIEW_ROOM_TEXT_KEYS,
		...WE_SPIN_CANCELLED_ROOM_TEXT_KEYS,
		...WE_SPIN_SPECTATOR_ROOM_TEXT_KEYS,
		...WE_SPIN_TIPPING_ROOM_TEXT_KEYS,
		...WE_SPIN_GAME_VIEW_TEXT_KEYS,
		...WE_SPIN_CHAT_ROOM_TEXT_KEYS,
		...WE_SPIN_ACCOUNT_TEXT_KEYS,
		...WE_SPIN_STREAMER_IN_GAME_HEADER_TEXT_KEYS,
		...WE_SPIN_ONBOARDING_TEXT_KEYS,
		...WE_SPIN_SEO,
		...WE_SPIN_EVENT_TAG_ALL_TEXT_KEYS,
		...WE_SPIN_NOTIFICATION_TEXT_KEYS,
		...WE_SPIN_SHARE_TEXT_KEYS,
		...WE_SPIN_CLIP_TEXT_KEYS,
		...WE_SPIN_FOLLOW_STREAMER_TEXT_KEYS,
		...WE_SPIN_BECOME_PRIVATE_STREAMER_TEXT_KEYS,
		...WE_SPIN_FRIENDS_ONBOARDING_TEXT_KEYS,
		...WE_SPIN_RAFFLE_TEXT_KEYS,
		...WE_SPIN_MODALS_TEXT_KEYS
	])
];
